import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { models } from '../modele/modele-form';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-individuelle-accident',
  templateUrl: './individuelle-accident.component.html',
  styleUrls: ['./individuelle-accident.component.scss']
})
export class IndividuelleAccidentComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 4; // accueil + 2 étapes + récapitulatif
  
  // Formulaire principal
  souscriptionForm: FormGroup;
  pieceJointe: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  isFocus: boolean = false;
  hasPhoneError: boolean = false;
  
  // Données de configuration
  listTypeSexe = [{name:'Féminin', value:'Feminin'}, {name:'Masculin', value:'Masculin'}];
  listGaucherDroitier = [{name:'Gaucher', value:'Gaucher'}, {name:'Droitier', value:'Droitier'}];
  listDuree = [
    {name:'1 mois', value:'1'}, 
    {name:'3 mois', value:'3'}, 
    {name:'6 mois', value:'6'}, 
    {name:'1 an', value:'12'}, 
    {name:'1 an - 3 mois', value:'15'}, 
    {name:'1 an 6 mois', value:'18'}, 
    {name:'2 ans', value:'24'}
  ];
  
  // Configuration dates et patterns
  newDate = new Date();
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
  // Référence et données
  numeroSous: string;
  currentPays = "Côte d'Ivoire";
  
  // Gestion des fichiers
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  downloadFile: boolean = true;
  downloadIcon = "assets/images/file.png";
  
  // Configuration du produit
  typeProduitList: any = {
    questionnaireUrl: '/assets/fileDownload/questionnaire_default.pdf'
  };

  // Données slide pour le banner
  slideData;
  lien = "";
  informations;
  title = "";

  // Prospect (si applicable)
  currectProspect: any;

  // Configuration des étapes selon le modèle
  formSteps: any[];
  currentFiliale = JSON.parse(localStorage.getItem('currentFiliale'));
  idGlobal: any;

  private leadSaved: boolean = false;

    // ===== AJOUT POUR AUTOSAVE =====
  private autoSaveSubject$ = new Subject<any>();
  private autoSaveSubscription: Subscription;
  private lastSavedData: string = ''; // Pour comparer les données
  // ================================

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    this.numeroSous = "IA" + time;

    // Configuration du slide banner
    // @ts-ignore
    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
        
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
      title: this.informations.title,
      subTitle: this.informations.subTitle,
      description: this.informations.description,
      img: this.informations.imgBackground,
      type: this.informations.type,
      imgIcon: this.informations.imgIcon
    }];

    // Charger la configuration des étapes depuis le modèle
    this.formSteps = this.informations?.Particulier || [];
  }

  ngOnInit() {
    this.initializeForm();
    this.setupAutoSave();
    this.loadTypeProduit();
  }

  // Initialisation du formulaire basée sur le modèle
  initializeForm() {
    this.souscriptionForm = this.fb.group({
      // Étape 1: Accident
      email: new FormControl('', [Validators.compose([Validators.required, Validators.pattern(this.emailPattern)])]),
      telephone: ['', Validators.required],
      adresse: ['', Validators.required],
      profession: ['', Validators.required],
      dateEffet: ['', Validators.required],
      duree: ['', Validators.required],
      gaucherDroitier: ['', Validators.required],
      
      // Étape 2: Informations personnelles
      nom: ['', Validators.required],
      prenom: ['', Validators.required],
      dateNaiss: ['', Validators.required],
      passport: ['', [Validators.required, Validators.pattern('[A-Za-z0-9]*')]],
      sexe: ['', Validators.required]
    });

    // FormGroup séparé pour la pièce jointe
    this.pieceJointe = new FormGroup({
      file: new FormControl('')
    });
  }

  // Navigation entre les étapes
  nextStep() {
    if (this.currentStep === 0) {
      // Depuis la page d'accueil, on va directement à l'étape 1
      this.currentStep = 1;
      setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      return;
    }
    
    if (this.isCurrentStepValid()) {
      if (this.currentStep < 3) {
        this.currentStep++;
        setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      }
    } else {
      this.markFormGroupTouched();
      this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Validation des étapes
  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 1: // Accident
        return this.souscriptionForm.get('telephone')?.valid && 
               this.souscriptionForm.get('adresse')?.valid &&
               this.souscriptionForm.get('profession')?.valid &&
               this.souscriptionForm.get('dateEffet')?.valid &&
               this.souscriptionForm.get('duree')?.valid &&
               this.souscriptionForm.get('gaucherDroitier')?.valid;
      
      case 2: // Informations personnelles
        return this.souscriptionForm.get('nom')?.valid && 
               this.souscriptionForm.get('prenom')?.valid &&
               this.souscriptionForm.get('dateNaiss')?.valid &&
               this.souscriptionForm.get('passport')?.valid &&
               this.souscriptionForm.get('sexe')?.valid;
      
      default:
        return true;
    }
  }

  markFormGroupTouched() {
    Object.keys(this.souscriptionForm.controls).forEach(key => {
      const control = this.souscriptionForm.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }

  // Progression
  getProgressPercentage(): number {
    const progressSteps = {
      0: 0,   // Page d'accueil
      1: 33,  // Étape 1 sur 3
      2: 66,  // Étape 2 sur 3
      3: 100  // Récapitulatif
    };
    
    return progressSteps[this.currentStep] || 0;
  }

  getProgressText(): string {
    const progressTexts = {
      0: 'Bienvenue...',
      1: 'Informations sur l\'accident...',
      2: 'Informations personnelles...',
      3: 'Finalisation...'
    };
    
    return progressTexts[this.currentStep] || 'Chargement en cours...';
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          if (type) {
            this[type + '_VALUE'] = docBase64Path;
          }
          
          // Déterminer l'icône selon le type de fichier
          let image = '';
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();
    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointe.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointe.get('file')?.setValue('');
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_default.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Chargement de la configuration du produit
  loadTypeProduit() {
    this.rechercheService.listProduit().subscribe(response => {
      if (response['responseCode'] === 200) {
        this.typeProduitList = response['data'].find((el: any) => 
          el.code === 'ASSURANCE_IA'
        );        
      }
    });
  }

  // Sauvegarde des données
  saveData() {
    this.sendingRequest = true;
    this.loader = true;
    
    const finalData = {
      ...this.souscriptionForm.value,
      pieceJointe: this.pieceJointe.value,
      numeroSous: this.numeroSous
    };

    const submissionData = {
      designationClient: `${finalData.prenom} ${finalData.nom}`,
      telephone: finalData.telephone,
      email: finalData.email,
      adresse: finalData.adresse,
      typeRisque: "IA",
      content: JSON.stringify(finalData),
      prospect: this.currectProspect ? this.currectProspect : null
    };
    
    this.rechercheService.saveSouscriptionOffline(submissionData)
      .subscribe(response => {
        if (response['responseCode'] == 200) {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.success("Souscription individuelle accident enregistrée avec succès");
          this.currentStep = 4; // Étape succès
        } else {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.error(response['cause'].erreurs[0].message);
        }
      }, errors => {
        this.sendingRequest = false;
        this.loader = false;
        const errorMessage = errors['error']['cause'].erreurs ? 
          errors['error']['cause'].erreurs[0].message : 
          errors['error']['cause']['message'];
        this.toastr.error(errorMessage);
      });
  }

  // Reset du formulaire
  resetForm() {
    this.currentStep = 0;
    this.souscriptionForm.reset();
    this.pieceJointe.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    this.downloadFile = true;
    window.scrollTo(0, 0);
    
    // Réinitialiser le numéro de souscription
    let time = new Date().getTime();
    this.numeroSous = "IA" + time;
  }

  // Utilitaires téléphone
  hasError(event: any, field: string, form: string) {
    this.hasPhoneError = !event;
    let currentValue = this.souscriptionForm.get(field)?.value;
    
    if (this.currentPays == 'Côte d\'Ivoire' && this.hasPhoneError) {
      if (currentValue != '') {
        if (currentValue.includes("+225") && currentValue.length != 14) {
          this.hasPhoneError = true;
          let val = currentValue.replace('+225', '');
          this.souscriptionForm.get(field)?.setValue(val);
        } else if ((currentValue.length == 10) && !currentValue.includes("+225")) {
          this.hasPhoneError = false;
          let value = '+225' + currentValue;
          this.souscriptionForm.get(field)?.setValue(value);
        } else if (currentValue.includes("+225") && currentValue.length == 14) {
          let val = currentValue.replace('+225', '');
          this.souscriptionForm.get(field)?.setValue(val);
          this.hasPhoneError = false;
        }
      }
    } else if (this.currentPays == 'Côte d\'Ivoire' && !this.hasPhoneError) {
      let val = currentValue.replace('+225', '');
      this.souscriptionForm.get(field)?.setValue(val);
      this.hasPhoneError = true;
    }
  }

  getNumber(number: string, field: string, form: string) {
    if (this.currentPays != 'Côte d\'Ivoire') {
      this.souscriptionForm.get(field)?.setValue(number);
    }
  }

  telInputObject(obj: any) {
    // Gestion de l'objet téléphone
  }

  onCountryChange(country: any) {
    let value = country['name'].toString();
    let val = "";
    for (let i = 0; i < value.length; i++) {
      if (value[i] == '(') {
        val = value.substring(0, i - 1);
        this.currentPays = val;
      } else {
        this.currentPays = value;
      }
    }
  }


  //   autoSave() { 
  //   const finalData = {
  //     ...this.souscriptionForm.value
  //   };

  //   let data = {
  //           "telephone": finalData.telephone,
  //           "email": finalData.email,
  //           "adresse": finalData.adresse,
  //           "type": "Assurance INDIVIDUELLE ACCIDENTS",
  //           "displayName": `${finalData.prenom} ${finalData.nom}`,
  //           "filiale": this.currentFiliale?.id,
  //           'prenom': finalData.prenom,
  //           'nom': finalData.nom,
  //   };
  //   this.rechercheService.autoSave(data)
  //     .subscribe(response => {
        
  //     }, errors => {
  //     });
  // }

  // ===== CONFIGURATION DE L'AUTOSAVE =====
  private setupAutoSave() {
    this.autoSaveSubscription = this.autoSaveSubject$.pipe(
      debounceTime(1000),
      distinctUntilChanged((prev, curr) => {
        return prev.email === curr.email && prev.telephone === curr.telephone;
      }),
      switchMap(data => {
        const currentDataString = JSON.stringify({
          email: data.email,
          telephone: data.telephone
        });
        
        if (currentDataString === this.lastSavedData) {
          return of(null);
        }
        
        this.lastSavedData = currentDataString;
        
        return this.rechercheService.autoSave(data).pipe(
          catchError(error => {
            return of(null);
          })
        );
      })
    ).subscribe(response => {
    });
  }

  // ===== MÉTHODE AUTOSAVE AMÉLIORÉE =====
  autoSave() {
    const formValue = this.souscriptionForm?.value;
    if (!formValue) return;

    const hasValidEmail = formValue.email && this.emailPattern.test(formValue.email);
    
    const hasValidPhone = formValue.telephone && formValue.telephone.trim().length >= 8;

    if (!hasValidEmail && !hasValidPhone) {
      return;
    }

    if (!this.currentFiliale?.id) {
      return;
    }

    const data = {
            "telephone": formValue.telephone?.trim(),
            "email": formValue.email?.trim().toLowerCase(),
            "adresse": formValue.adresse,
            "type": "Assurance INDIVIDUELLE ACCIDENTS",
            "displayName": `${formValue.prenom} ${formValue.nom}`,
            "filiale": this.currentFiliale?.id,
            'prenom': formValue.prenom,
            'nom': formValue.nom,
    };

    this.autoSaveSubject$.next(data);
  }
  // ========================================

   getDevisAutre() {
        this.currentStep = 0;
        setTimeout(() => {
            window.scrollTo({
                top: 600,
                behavior: 'smooth'
            });
        }, 100);
  }

}